export default __webpack_public_path__ + "static/media/bell_filled.2aec5416.svg";